module.exports = __webpack_public_path__ + "static/media/s_cur_03.843f3099.png";